// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { thumbDown16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-thumb-down': IconThumbDown;
    }
}

/**
 * The icon component for the 'thumbDown' icon
 */
export class IconThumbDown extends IconSvg {
    public constructor() {
        super(thumbDown16X16);
    }
}

registerIconSvg('icon-thumb-down', IconThumbDown);
export const iconThumbDownTag = 'nimble-icon-thumb-down';
